import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="fade-in min-h-[70vh] flex items-center justify-center px-6">
    <div className="card-surface p-12 max-w-lg w-full text-center" data-testid="payment-cancel-page">
      <XCircle className="mx-auto text-neutral-500 mb-4" size={48} />
      <h1 className="font-display text-3xl mb-2">No charge made.</h1>
      <p className="text-neutral-400 mb-8">The checkout was cancelled. You can come back anytime.</p>
      <Link to="/studio" className="btn-primary px-5 py-2.5">Back to The Studio</Link>
    </div>
  </div>
);

export default PaymentCancel;
